import { Box } from '@factorialco/deprecated-design-system'
import { Widget } from '@factorialco/f0-react/dist/experimental'
import { isEmpty } from 'lodash'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { fromCents } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency, { isCurrency } from 'modules/core/lib/money'

import { Expensable } from 'modules/expenses/types/Expensable'

import { CustomTwoColumnsList } from '../CustomTwoColumnList'
import CustomWidgetHeaderButton from './CustomWidgetHeaderButton'

interface MileageInformationWidgetProps {
  expensable: Expensable
  editable: boolean
  onEdit: () => void
}

const buildMileageInformationList = (expensable: Expensable, locale: string) => {
  const mileage = expensable?.mileage?.mileage ?? 0
  const amount = parseInt(expensable?.amount ?? '0')
  const currency = expensable?.currency
  const unit = expensable?.mileage?.units
  const rate = expensable?.mileage?.rate

  const totalReimbursement = isCurrency(currency)
    ? MoneyWithCurrency({
        amount: amount,
        currency,
        locale,
      })
    : ''

  const rateTitle = i18n.t(
    'expenses_v2.confirmation_screen.expense.mileage_information_block.rate',
    {
      unit,
    }
  )
  const items = [
    {
      title: i18n.t(
        'expenses_v2.confirmation_screen.expense.mileage_information_block.total_reimbursement'
      ),
      info: totalReimbursement,
    },
    {
      title: rateTitle,
      info: rate + '/' + unit,
    },
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.mileage_information_block.mileage'),
      info: fromCents(mileage) + ' ' + unit,
    },
  ]

  return items.filter(({ info }) => !isEmpty(info))
}

const MileageInformationWidget = ({
  expensable,
  editable,
  onEdit,
}: MileageInformationWidgetProps) => {
  const { access } = useCurrentSession()
  const { locale } = access

  const list = buildMileageInformationList(expensable, locale)

  return (
    <Box gap="s16" position="relative">
      <Widget
        header={{
          title: i18n.t('expenses_v2.confirmation_screen.expense.mileage_information_block.title'),
        }}
      >
        <CustomTwoColumnsList list={list} />
      </Widget>
      {editable && (
        <CustomWidgetHeaderButton
          label={i18n.t('expenses_v2.confirmation_screen.confirmation_screen_block_edit_action')}
          onClick={onEdit}
        />
      )}
    </Box>
  )
}

export default MileageInformationWidget
